import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import RiskCard from '../components/RiskCard';
import NextStepsTable from '../components/NextStepsTable';
import SectionTitle from '../components/SectionTitle';

// Title + first item kept together via wrap={false} so the title never
// orphans at the bottom of a page.

export const RisksSection = ({ report }) => {
  const risks = report.risks || [];
  if (!risks.length) return null;
  const title = report.variant === 'shared' ? 'Things to address' : 'Risks';
  return (
    <View>
      <View wrap={false}>
        <SectionTitle>{title}</SectionTitle>
        <RiskCard risk={risks[0]} />
      </View>
      {risks.slice(1).map((r, i) => <RiskCard key={i + 1} risk={r} />)}
    </View>
  );
};

export const NextStepsSection = ({ report }) => {
  const steps = report.nextSteps || [];
  if (!steps.length) return null;
  return (
    <View wrap={false}>
      <SectionTitle>Next Steps</SectionTitle>
      <NextStepsTable steps={steps} />
    </View>
  );
};

const RisksAndNextStepsSection = ({ report }) => (
  <>
    <RisksSection report={report} />
    <View style={{ height: space.md }} />
    <NextStepsSection report={report} />
  </>
);

export default RisksAndNextStepsSection;
